<header>
    <div class="">
        <div class="logo-login ">
            <div class="logo-login-main">
                <div class="img-logo">
                    <img style="width: 65px; height: 65px; margin-top: -5px;"
                        src="./assets/img/logo-projects/emblemofnorthvietnam.png">
                </div>
                <div class="title-logo">
                    <div class="title-red">
                    </div>
                    <div class="title-blue">
                        <P>BỘ GIÁO DỤC VÀ ĐÀO TẠO</P>
                        <P>QUẢN LÝ GIÁO DỤC NGƯỜI KHUYẾT TẬT VIỆT NAM</P>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

<section>
    <img class="backgroundImg" src="./assets/img/logo-projects/ncse.png">
    <ng-container *ngIf="isToken === false">
        <div class="zidbody">
            <div class="zidforgot clearfix">
                <h2 class="formheader">Xác nhận mã OTP</h2>
            </div>
            <form nz-form style="padding-top:12px;padding-left:25px" [formGroup]="validateForm" autocomplete="off">
                <div nz-row [nzGutter]="['0','0']">
                    <div nz-col nzSm="24" nzMd="24">
                        <nz-form-item>
                            <nz-form-label nzSpan="24" nzFor="otpCode" nzRequired><span
                                    style="font-weight: bolder;">Nhập mã OTP</span></nz-form-label>
                            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                                <input nz-input formControlName="otpCode" name="otpCode" type="text"
                                    placeholder="Nhập mã OTP">
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div>
                        <a [routerLink]="['/resetmatkhau']"><span class="forgotPass">Quay lại trang xác thực</span></a>
                    </div>
                </div>
                <div class="zidfbot">
                    <button class="zidcancelbtn" nz-button nzType="primary" type="submit" (click)="SubmitOTP()">Xác
                        nhận</button>
                </div>
            </form>

        </div>
    </ng-container>
    <ng-container *ngIf="isToken === true">
        <div class="zidbody">
            <div class="zidforgot clearfix">
                <h2 class="formheader">Thay đổi mật khẩu</h2>
            </div>
            <form nz-form style="padding-top:12px;padding-left:25px" [formGroup]="validateFormChange" autocomplete="off">
                <div nz-row [nzGutter]="['0','0']">
                    <div nz-col nzSm="24" nzMd="24">
                        <nz-form-item>
                            <nz-form-label nzSpan="24" nzFor="password" nzRequired><span
                                    style="font-weight: bolder;">Mật khẩu mới</span></nz-form-label>
                            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                                <input nz-input formControlName="password" name="password" type="password"
                                    placeholder="Nhập mật khẩu mới">
                            </nz-form-control>
                        </nz-form-item>
                    </div>

                    <div nz-col nzSm="24" nzMd="24">
                        <nz-form-item>
                            <nz-form-label nzSpan="24" nzFor="confirmPassword" nzRequired><span
                                    style="font-weight: bolder;">Nhập lại mật khẩu</span></nz-form-label>
                            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                                <input nz-input formControlName="confirmPassword" name="confirmPassword" type="password"
                                    placeholder="Nhập lại mật khẩu">
                            </nz-form-control>
                        </nz-form-item>
                    </div>

                </div>
                <div class="zidfbot">
                    <button class="zidcancelbtn" nz-button nzType="primary" type="submit" (click)="Submit()">Xác
                        nhận</button>
                    <button class="zidnextbtn" nz-button [routerLink]="['/dangnhap']">Bỏ qua</button>&nbsp;
                </div>
            </form>
        </div>
    </ng-container>
</section>

<footer>
    <div class="container-fuild">
        <div class="copyright-login text-center">
            <p></p>
        </div>
    </div>
</footer>
